<template>
    <button
        @click="go"
        v-show="!notIdeal"
        class="vod-link"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
    >

        <transition name="fade">
            <portal to="details-overlay">
                <div class="expanded-details-modal" v-if="expanded">
                    <div class="backdrop" @click.stop="toggleExpand"> </div>
                    <div class="details-wrapper">
                        <OnDemandDetails
                            :contentType="saved ? media.contentType : media.type"
                            :contentId="media.id"
                            :embeded="true"
                            :detailsOnly="false"
                        />
                    </div>
                </div>
            </portal>
        </transition>

        <transition name="fade">
            <div class="trailer-mode" v-show="trailerMode" :style="trailerStyle" @wheel="onTrailerWheel">

                <span class="release-badge" :class="releaseBadge.kind" v-if="releaseBadge">{{ releaseBadge.label }}</span>

                <div class="video-container">
                    <EmbedTrailer ref="trailer" :embedKey="trailerUrl" :delay="false" v-if="trailerMode && trailerUrl" />
                    <img class="trailer-logo" :src="trailerLogo" v-if="trailerLogo" />
                </div>

                <div class="chin">
                    <div class="chin-actions">
                        <button class="icon-btn play" @click.stop="go" title="Play">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
                        </button>
                        <button class="icon-btn" @click.stop="save" title="Add to My List" :class="[isInSaves ? 'saved' : '', justSaved ? 'save-pop' : '']">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        <button class="icon-btn like" :class="{active: liked}" @click.stop="toggleLike" title="Like">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>
                        </button>
                        <button class="icon-btn mute" :class="{active: !muted}" @click.stop="toggleMute" title="Toggle Mute">
                            <svg v-if="muted" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M17 14L19.0005 12M21 10L19.0005 12M19.0005 12L17 10M19.0005 12L21 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3 14V10C3 9.44772 3.44772 9 4 9H6.69722C6.89465 9 7.08766 8.94156 7.25192 8.83205L11.4453 6.03647C12.1099 5.59343 13 6.06982 13 6.86852V17.1315C13 17.9302 12.1099 18.4066 11.4453 17.9635L7.25192 15.1679C7.08766 15.0584 6.89465 15 6.69722 15H4C3.44772 15 3 14.5523 3 14Z" stroke="currentColor" stroke-width="1.5"/> </svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M2 14V10C2 9.44772 2.44772 9 3 9H5.69722C5.89465 9 6.08766 8.94156 6.25192 8.83205L10.4453 6.03647C11.1099 5.59343 12 6.06982 12 6.86852V17.1315C12 17.9302 11.1099 18.4066 10.4453 17.9635L6.25192 15.1679C6.08766 15.0584 5.89465 15 5.69722 15H3C2.44772 15 2 14.5523 2 14Z" stroke="currentColor" stroke-width="1.5"/> <path d="M16.5 7.5C16.5 7.5 18 9 18 11.5C18 14 16.5 15.5 16.5 15.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M19.5 4.5C19.5 4.5 22 7 22 11.5C22 16 19.5 18.5 19.5 18.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                        </button>

                        <button class="icon-btn more" @click.stop="toggleExpand" title="More info">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>
                        </button>

                    </div>

                    <div class="chin-meta" v-if="ratingDisplay || yearDisplay || typeLabel">
                        <span class="pill rating" v-if="ratingDisplay">
                            <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z"/></svg>
                            {{ ratingDisplay }}
                        </span>
                        <span class="pill" v-if="yearDisplay">{{ yearDisplay }}</span>
                        <span class="pill" v-if="typeLabel">{{ typeLabel }}</span>
                        <span class="pill quality">HD</span>
                    </div>

                    <div class="chin-genres" v-if="media.genres && media.genres.length">
                        <span class="genre-pill" v-for="(genre, i) in media.genres" :key="i">{{ genre }}</span>
                    </div>
                </div>
            </div>
        </transition>
        <template>
            <div class="number-vod" :class="{list: list, animated: loader, display: display, twodigits: number.length === 2}" v-if="number">
                <span> {{number}} </span>
                <img v-if="saved" class="poster" :src="media.imgs[0]"/>
                <img v-else class="poster" :src="media.poster_path"/>
            </div>

            <div class="vod" :class="{list: list, animated: loader, display: display}" v-else>
                <div class="poster animated" v-if="!loaded" />

                <transition name="fade">
                    <img class="poster" :src="img" v-on:load="onLoaded" v-on:error="getImage" v-show="loaded" v-if="!loader"  />
                </transition>

                <img v-if="logo" :src="logo" class="logo"/>
                <b v-if="allfailed" :src="logo" class="logo fail">
                    {{media.title || media.name}}
                </b>

                <transition name="fade">
                    <span v-show="loaded">
                        {{ media.title || media.name }}
                    </span>
                </transition>

            </div>
        </template>
    </button>
</template>
<script>


const EmbedTrailer = () => import("@/components/desktop/EmbededTrailer");
const OnDemandDetails = () => import("@/views/Details.vue");

export default {
    name: 'vodcomponent',

    components: {
        EmbedTrailer,
        OnDemandDetails
    },

    props: {
        media: Object,

        number: String,
        display: {
            type: Boolean,
            default: function(){ return false }
        },

        list: {
            type: Boolean,
            default: function(){ return false }
        },

        saved: {
            type: Boolean,
            default: function(){ return false }
        },
        history: {
            type: Boolean,
            default: function(){ return false }
        },
        existingSaves: {
            type: Array,
            default: function(){ return [] }
        }
    },

    data: function(){
        return {
            img: 'http://fail.fail.jpg',
            loaded: false,
            notIdeal: false,
            logo: null,
            isInSaves: false,
            justSaved: false,
            expanded: false,
            saveAnimTimer: null,
            trailerLogo: null,
            trailerUrl: null,
            loader: false,
            muted: true,
            allfailed: false,
            trailerMode: false,
            trailerStyle: {},
            hoverTimer: null,
            liked: false,
            historyBadge: null,
            historyEntryFound: false,
            historyResolved: false,
        }
    },

    watch:{
        media: function(){
           // this.loader = this.media.title == 'Loading...'
        }
    },

    computed: {
        posterPath(){
            return this.saved ? this.media.imgs[1] : this.media.backdrop_path
        },
        ratingDisplay(){
            if(this.saved){return null}
            const v = this.media && this.media.vote_average
            return (typeof v === 'number' && v > 0) ? v.toFixed(1) : null
        },

        yearDisplay(){
            if(this.saved){return null}
            const d = this.media && this.media.date
            if(!d) return null
            const y = new Date(d).getFullYear()
            return isNaN(y) ? null : y
        },

        releaseBadge(){
            if(this.history && this.getType() === 'tv' && this.historyEntryFound){
                return this.historyResolved ? this.historyBadge : null
            }
            return this.defaultReleaseBadge
        },

        defaultReleaseBadge(){
            if(!this.media) return null
            const isTv = this.getType() === 'tv'
            const d = this.media.date
            if(!d) return null

            const t = new Date(d).getTime()
            if(isNaN(t)) return null

            const now = Date.now()
            const thirtyDays = 30 * 24 * 60 * 60 * 1000

            if(t > now){
                return { kind: 'upcoming', label: 'Coming Soon' }
            }
            if(now - t <= thirtyDays){
                return { kind: 'fresh', label: isTv ? 'New' : 'Just Released' }
            }
            return null
        },

        typeLabel(){
            if(!this.media) return null
            return (this.getType() === 'tv') ? 'TV Series' : 'Movie'
        },
    },

    methods: {
        getType(){
            return this.saved ? this.media.contentType : this.media.type
        },

        getWodHistoryEntry(){
            let list = []
            try{
                list = JSON.parse(localStorage.getItem('WODHistory')) || []
            }catch(e){
                list = []
            }

            if(!Array.isArray(list)) return null
            return list.find(item => item && String(item.id) === String(this.media.id)) || null
        },

        async fetchSeasonEpisodes(season){
            const req = await window.afetch(`/season?id=${this.media.id}&type=tv&season=${season}`)
            if(!req.ok) throw new Error('Failed to load season')
            const data = await req.json()
            if(!data || !Array.isArray(data.episodes)) throw new Error('Invalid season response')
            return data.episodes
        },

        sortEpisodes(episodes){
            return [...episodes].sort((a, b) => {
                const aNum = Number(a && a.episode_number)
                const bNum = Number(b && b.episode_number)
                return (isNaN(aNum) ? 0 : aNum) - (isNaN(bNum) ? 0 : bNum)
            })
        },

        findNextEpisode(episodes, episode){
            const sorted = this.sortEpisodes(episodes)
            const index = sorted.findIndex(ep => Number(ep.episode_number) === episode)
            if(index !== -1) return sorted[index + 1] || null
            return sorted.find(ep => Number(ep.episode_number) > episode) || null
        },

        parseAirDate(value){
            const [y, m, d] = String(value || '').split('-').map(Number)
            if(!y || !m || !d) return null
            return new Date(y, m - 1, d)
        },

        getLatestAiredDate(episodes, today){
            return episodes.reduce((latest, episode) => {
                const airDate = this.parseAirDate(episode && episode.air_date)
                if(!airDate || airDate > today) return latest
                return !latest || airDate > latest ? airDate : latest
            }, null)
        },

        getShowLatestAiredDate(episodes, today){
            let latest = this.getLatestAiredDate(episodes, today)
            const lastEpisode = this.media && this.media.last_episode_to_air
            const mediaLatest = this.parseAirDate(lastEpisode && lastEpisode.air_date)
            if(mediaLatest && mediaLatest <= today && (!latest || mediaLatest > latest)){
                latest = mediaLatest
            }
            return latest
        },

        buildEpisodeBadge(episode, episodes){
            const airDate = this.parseAirDate(episode && episode.air_date)
            if(!airDate) return undefined

            const today = new Date()
            today.setHours(0, 0, 0, 0)
            const todayDay = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())

            if(airDate > today){
                const airDay = Date.UTC(airDate.getFullYear(), airDate.getMonth(), airDate.getDate())
                const days = Math.round((airDay - todayDay) / (24 * 60 * 60 * 1000))
                return {
                    kind: 'waiting',
                    label: days === 1 ? 'Next episode in 1 day' : `Next episode in ${days} days`
                }
            }

            const latestAired = this.getShowLatestAiredDate(episodes, today)
            if(latestAired){
                const latestDay = Date.UTC(latestAired.getFullYear(), latestAired.getMonth(), latestAired.getDate())
                const daysSinceLatest = Math.round((todayDay - latestDay) / (24 * 60 * 60 * 1000))
                if(daysSinceLatest >= 30) return null
            }

            return { kind: 'available', label: 'New episodes' }
        },

        isLastAirDateStale(){
            const lastAirDate = this.parseAirDate(this.media && this.media.last_air_date)
            if(!lastAirDate) return false

            const today = new Date()
            const todayDay = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
            const lastAirDay = Date.UTC(lastAirDate.getFullYear(), lastAirDate.getMonth(), lastAirDate.getDate())
            const daysSinceLastAir = Math.round((todayDay - lastAirDay) / (24 * 60 * 60 * 1000))
            return daysSinceLastAir > 30
        },

        async resolveHistoryBadge(){
            const entry = this.getWodHistoryEntry()
            if(!entry) return

            if(this.isLastAirDateStale()) return

            const season = parseInt(entry.season)
            const episode = parseInt(entry.episode)
            if(isNaN(season) || season < 0 || isNaN(episode) || episode < 0) return

            this.historyEntryFound = true

            try{
                let episodes = await this.fetchSeasonEpisodes(season)
                if(!episodes.length){
                    this.historyEntryFound = false
                    return
                }

                let nextEpisode = this.findNextEpisode(episodes, episode)

                if(!nextEpisode){
                    episodes = await this.fetchSeasonEpisodes(season + 1)
                    nextEpisode = this.sortEpisodes(episodes)[0] || null
                }

                if(!nextEpisode){
                    this.historyBadge = null
                    this.historyResolved = true
                    return
                }

                const badge = this.buildEpisodeBadge(nextEpisode, episodes)
                if(badge === undefined){
                    this.historyEntryFound = false
                    return
                }

                this.historyBadge = badge
                this.historyResolved = true
            }catch(e){
                this.historyEntryFound = false
                this.historyResolved = false
            }
        },

        toggleMute(){
            this.$refs.trailer.toggleMute()
            this.muted = !this.muted
        },
        go(e) {
            const url = '/theater?mode=od&type=' + this.getType() + '&id=' + this.media.id

            if (e.ctrlKey || e.metaKey || e.shiftKey) {
                window.open(url, '_blank')
                return
            }

            this.$router.push(url)
        },
        toggleExpand(){
            this.expanded = !this.expanded
            this.trailerMode = false
        },
        goSource(){
            this.$router.push(`/${this.getType()}/${this.media.id}`)
        },

        async getTrailer(){
            if(!this.trailerUrl){
                const req = await window.afetch(`/trailer?id=${this.media.id}&type=${this.getType()}`)
                const res = await req.json()
                this.trailerUrl = res.url
                this.trailerLogo = res.logo
            }
        },

        async makeImage(){
            try{
                const req = await window.afetch(`/logo?id=${this.media.id}&type=${this.getType()}`)
                const res = await req.json()
                const backdropPath = this.saved ? this.media.imgs[1] : this.media.backdrop_path
                if(!backdropPath){
                    this.notIdeal = true
                    return
                }

                this.img = backdropPath
                if(res.logo && res.logo !== ''){
                    this.logo =  res.logo
                }else{
                    this.allfailed = true
                }

            }catch(e){
                this.allfailed = true
            }
        },

        async getImage(){
            try{
                const req = await window.afetch(`/thumbnail?id=${this.media.id}&type=${this.getType()}`)
                const res = await req.json()

                if(res.url){
                    this.img = res.url
                }else{
                    this.makeImage()
                }
            }catch(e){
                this.makeImage()
            }
        },

        onLoaded: async function() {
            this.loaded = true;
        },


        async save(){
            let data = {
                type: 'od',
                id: `${this.media.id}`,
                ref: `${window.location.origin}/${this.getType()}/${this.media.id}`,
                name: (this.media.title || this.media.name),
                imgs: this.saved ? this.imgs : [this.media.poster_path, this.media.backdrop_path],
                contentType: this.getType(),
                date: this.media.date
            }

            const req = await window.afetch(`/save`, {method: 'POST', body: JSON.stringify(data) })
            const res = await req.json()
            this.isInSaves = res.saved

            if(res.saved){
                clearTimeout(this.saveAnimTimer)
                this.justSaved = true
                this.saveAnimTimer = setTimeout(() => {
                    this.justSaved = false
                }, 650)

            }

            this.$root.$emit('savesUpdated')

        },

        toggleLike(){
            this.liked = !this.liked
            this.$emit('toggle-like', { media: this.media, liked: this.liked })
        },

        onMouseEnter(){
            clearTimeout(this.hoverTimer)

            this.hoverTimer = setTimeout(() => {
                if(!this.trailerUrl){this.getTrailer()}
                this.positionTrailer(true)
                this.trailerMode = true
                this.startTrackingPosition()
            }, 700)
        },

        onMouseLeave(){
            clearTimeout(this.hoverTimer)
            this.trailerMode = false
            this.stopTrackingPosition()
            this.muted = true
        },

        positionTrailer(initialPosition=false){
            const rect = this.$el.getBoundingClientRect()
            const pageWidth = window.innerWidth

            let top = rect.top - 50
            let left = rect.left
            if(this.number){
                if(this.number.length > 1){
                    left = left + 20
                }else{
                    left = left - 30
                }
            }else{
                left = left - 100
            }


            if(initialPosition){
                if(left < 0){ //out of bounds left
                    left = 24
                }else if((rect.right) >= pageWidth){ //out of bounds right
                    left = pageWidth - 506
                }
            }

            this.trailerStyle = { top: `${top}px`, left: `${left}px` }
        },

        onTrackedScroll(){
            if (this._rafId) return
            this._rafId = requestAnimationFrame(() => {
                this._rafId = null
                this.positionTrailer()
            })
        },

        startTrackingPosition(){
            if (this._tracking) return
            this._tracking = true
            window.addEventListener('scroll', this.onTrackedScroll, { passive: true, capture: true })
            window.addEventListener('resize', this.onTrackedScroll, { passive: true })
        },

        stopTrackingPosition(){
            if (!this._tracking) return
            this._tracking = false
            window.removeEventListener('scroll', this.onTrackedScroll, true)
            window.removeEventListener('resize', this.onTrackedScroll)
            if (this._rafId) {
                cancelAnimationFrame(this._rafId)
                this._rafId = null
            }
        },

        onTrailerWheel(e){
            // Only redirect horizontal wheel movement to the row (since the
            // trailer overlay sits outside its visible bounds). Leave
            // vertical movement alone so the page can still scroll normally
            // while a trailer is open.
            if(Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return

            const scrollEl = this.findScrollParent(this.$el)
            if(!scrollEl) return

            e.preventDefault()
            scrollEl.scrollLeft += e.deltaX
        },

        findScrollParent(el){
            let node = el && el.parentElement
            while(node && node !== document.body && node !== document.documentElement){
                const style = getComputedStyle(node)
                const canScrollX = /(auto|scroll)/.test(style.overflowX) && node.scrollWidth > node.clientWidth
                const canScrollY = /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight
                if(canScrollX || canScrollY) return node
                node = node.parentElement
            }
            return document.scrollingElement || document.documentElement
        },
    },

    mounted: function(){
        const forcedLoader = this.media.title == 'Loading...'
        this.loader = forcedLoader
        if(this.saved || this.existingSaves.find((x) => { return x.id == this.media.id })){
            this.isInSaves = true
        }
        if(this.history && this.getType() === 'tv'){
            this.resolveHistoryBadge()
        }
    },

    beforeDestroy: function(){
        this.stopTrackingPosition()
        clearTimeout(this.saveAnimTimer)
    }
}
</script>

<style scoped lang="scss">

.vod-link{
    background-color: transparent;
    border: none;
    cursor: pointer;
    overflow: visible;
    position: relative;
}

.trailer-mode{
    position: fixed;
    width: 500px;
    background-color: #141414;
    z-index: 9999;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 0px 40px -8px rgba(0, 0, 0, 0.85);
    transition: none;
    transition: opacity 0.3s;
}

.release-badge{
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 3;
    padding: 4px 10px;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    line-height: 1.4;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    pointer-events: none;

    &.upcoming{
        background-color: rgba(229, 9, 20, 0.92);
    }

    &.fresh{
        background-color: rgba(37, 99, 235, 0.92);
    }

    &.waiting{
        background-color: rgba(245, 197, 24, 0.95);
        color: #141414;
    }

    &.available{
        background-color: rgba(37, 99, 235, 0.92);
    }
}

.video-container{
    position: relative;
    width: 100%;
    height: 280px;
    overflow: hidden;
    pointer-events: none;

    ::v-deep *{
        pointer-events: none !important;
    }

    &::after{
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 60px;
        background: linear-gradient(to bottom, transparent, #141414);
        pointer-events: none;
    }
}

.trailer-logo{
    position: absolute;
    width: 42%;
    height: auto;
    z-index: 2;
    bottom: 20px;
    left: 24px;
    filter: drop-shadow(0 4px 12px rgba(0,0,0,0.6));
}

.chin{
    position: relative;
    background-color: #141414;
    box-sizing: border-box;
    padding: 14px 22px 20px;
}


.chin-actions{
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;

    .icon-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        border-radius: 50%;
        border: 1.5px solid rgba(255,255,255,0.5);
        background: transparent;
        color: #fff;
        cursor: pointer;
        padding: 0;
        position: relative;
        transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, transform 0.1s ease;

        svg{
            width: 16px;
            height: 16px;

            path{
                transition: fill 0.2s ease;
            }
        }

        &:hover{
            background-color: #fff;
            border-color: #fff;
            color: #141414;
            transform: scale(1.05);
        }

        &.play{
            background-color: #fff;
            border-color: #fff;
            color: #141414;

            svg{ width: 15px; height: 15px; margin-left: 1px; }

            &:hover{ background-color: rgba(255,255,255,0.85); }
        }

        &.active{
            background-color: #fff;
            border-color: #fff;
            color: #141414;
        }

        &.more{
            margin-left: auto;
        }

        &.saved{
            background-color: #fff;
            border-color: #fff;
            color: #141414;

            svg path{
                fill: #141414;
            }

            &:hover{
                background-color: rgba(255,255,255,0.85);
                border-color: rgba(255,255,255,0.85);
                color: #141414;
                transform: scale(1.05);
            }
        }

        &.save-pop{
            animation: save-pop-bounce 0.55s cubic-bezier(.34, 1.56, .64, 1);

            svg path{
                animation: save-fill-in 0.4s ease-out forwards;
            }

            &::after{
                content: '';
                position: absolute;
                inset: 0;
                border-radius: 50%;
                border: 1.5px solid rgba(255, 255, 255, 0.9);
                animation: save-ring-pulse 0.6s ease-out;
                pointer-events: none;
            }
        }
    }
}

@keyframes save-pop-bounce{
    0%   { transform: scale(1); }
    35%  { transform: scale(1.28); }
    55%  { transform: scale(0.92); }
    75%  { transform: scale(1.06); }
    100% { transform: scale(1); }
}

@keyframes save-fill-in{
    0%   { fill: rgba(20,20,20,0); }
    100% { fill: #141414; }
}

@keyframes save-ring-pulse{
    0%   { transform: scale(0.7); opacity: 0.9; }
    100% { transform: scale(1.9); opacity: 0; }
}

@media (prefers-reduced-motion: reduce){
    .icon-btn.save-pop{
        animation: none;

        svg path{ animation: none; }

        &::after{ content: none; }
    }
}

.chin-meta{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 10px;

    .pill{
        display: inline-flex;
        align-items: center;
        gap: 4px;
        border: 1px solid rgba(255,255,255,0.4);
        border-radius: 4px;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.02em;
        color: #e5e5e5;
        line-height: 1.6;

        &.rating{
            color: #f5c518;
            border-color: rgba(245,197,24,0.55);

            svg{ width: 11px; height: 11px; fill: #f5c518; }
        }

        &.quality{
            color: #d2d2d2;
        }
    }
}

.chin-genres{
    display: flex;
    flex-wrap: wrap;
    gap: 6px;

    .genre-pill{
        border: 1px solid rgba(255,255,255,0.3);
        border-radius: 999px;
        padding: 3px 11px;
        font-size: 12px;
        color: #b3b3b3;
        background-color: rgba(255,255,255,0.04);
    }
}

.number-vod{
    position: relative;
    margin-right: 50px;
    transition: transform 0.25s ease;
    &:hover{
        opacity: 1;
        transform: scale(1.01);
    }

    span{
        color: white;
        font-weight: bold;
        font-size: 400px;
        margin: 0;
        padding: 0;
        position: absolute;
        top: -30px;
        left: 0;
        z-index: -1;
        opacity: 0.2;
    }
    img{
        border-radius: 12px;
        width: 250px;
        height: 350px;
        object-fit: cover;
        margin-left: 140px;
        box-shadow: 0 0px 40px -8px rgba(0, 0, 0, 0.85);
    }
    &.twodigits{
        margin-right: 100px;
        img{
            margin-left: 280px;
        }
    }
}

.vod{
    opacity: 0.9;
    width: 360px;
    height: 180px;
    border-radius: 12px;
    overflow: hidden;
    margin-right: 18px;
    position: relative;
    transition: transform 0.25s ease;
    &:hover{
        opacity: 1;
        transform: scale(1.01);
    }

    .logo{
        text-align: center;
        color: white;
        font-weight: bold;
        font-size: 23px;
        text-transform: uppercase;
        position: absolute;
        bottom: 12px;
        left: 10%;
        width: 80%;
        height: auto;
        &.fail{
            width: 95%;
            text-shadow: 0px 5px 14px #0b0b0b;
            left: 2.5%;
        }
    }
    .poster{
        border-radius: 12px;
        width: auto;
        min-width: 100%;
        height: 100%;
        object-fit: cover;
    }

}
</style>
